import React, { FC, useState, useEffect } from "react";
import styled, { css, keyframes } from "styled-components";

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOutAnimation = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const StyledTimedWarning = styled.div<{ show: boolean }>`
  height: 0;
  position: relative;
  transition: 1000ms ease;

  ${({ show }) =>
    show
      ? css`
          animation: ${fadeInAnimation};
          animation-duration: 500ms;
          animation-fill-mode: forwards;
        `
      : css`
          animation: ${fadeOutAnimation};
          animation-duration: 500ms;
          animation-fill-mode: forwards;
        `}
`;

const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.color.error};
  width: 100%;
`;

interface TimedWarningMessage {
  error?: string;
  delay?: string;
}

export const TimedWarning: FC<TimedWarningMessage> = ({ error, delay }) => {
  const [errorMsg, setError] = useState<string>();
  const [timer, setTimer] = useState<number>();
  const [hideTimer, setHideTimer] = useState<number>();
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    if (error) {
      if (error === errorMsg && timer) {
        clearTimeout(timer);
      }
      setError(error);
      setShow(true);
    }

    if (error && delay) {
      setTimer(
        window.setTimeout(() => {
          setShow(false);
          setHideTimer(
            window.setTimeout(() => {
              setError("");
            }, 550)
          );
        }, parseInt(delay))
      );
    }

    if (timer)
      return () => {
        if (timer) clearTimeout(timer);
        if (hideTimer) clearTimeout(hideTimer);
      };
    // Ignoring dep warning as this is complicated and it already works!
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <StyledTimedWarning show={show}>
      <ErrorMessage>{errorMsg}</ErrorMessage>
    </StyledTimedWarning>
  );
};
